import { Globals } from './../../../../globals';
import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { ProviderOrderAddDishPage } from '../provider-order-add-dish/provider-order-add-dish';
import { IngredientsServices } from '../../../ingredients/services';
import { ProvidersServices } from '../../services';
import { DishServices } from '../../../dish/services';
import { TranslateService } from '@ngx-translate/core';
import { ProductsServices } from '../../../products/services';

/**
 * Generated class for the ProviderOrderAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-provider-order-add',
  templateUrl: 'provider-order-add.html',
})
export class ProviderOrderAddPage {

  element: any;
  type: any;
  quantity: any = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    private toastCtrl: ToastController,
    private ingredientsServices: IngredientsServices,
    private providersServices: ProvidersServices,
    private dishServices: DishServices,
    public translate: TranslateService,
    public productsServices: ProductsServices) {

    this.element = this.navParams.get('element');
    this.type = this.navParams.get('type');
  }

  async add() {
    this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - Add to cart - Create', this.globals.restaurant.email, 'Create/Update', 'Create  add to cart', 'ProviderOrders', this.type);

    if (this.type == 'ingredient' || this.type == 'product') {
      this.insert(this.quantity, this.type, this.element.UID, 'manual');
      this.present();
    } else if (this.type == 'dish') {
      this.getInsertDish(this.element.UID, this.quantity);
      this.present();
    } else if (this.type == 'ingredient-comp') {
      this.getInsertIng(this.element.UID, this.quantity);
      this.present();
    } else if (this.type == 'product-comp') {
      this.getInsertProd(this.element.UID, this.quantity);
      this.present();
    }


  }

  insert(quantity, type, uid, insert) {
    //insert to cart
    this.ingredientsServices.afs.collection('cart').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'UID_USER': this.globals.user_uid,
      'quantity': quantity,
      'type': type,
      'uid': uid,
      'insert': insert,
    }).then(doc => {
      this.providersServices.getTotalCartElements(this.globals.restaurant_uid, this.globals.user_uid);
    });
  }


  async getInsertDish(uid, quantity) {
    var dish = await this.dishServices.getDish(uid);
    for (let element of this.globals.objectToArray(dish.foodcost)) {
      var ingredient = await this.ingredientsServices.getIngredient(element.uid);
      if (ingredient.sub_recipe) {
        for (let ing_foodcost of this.globals.objectToArray(ingredient.foodcost)) {
          //usamos el real_weight para sacar la cantidad que queremos
          var _real_quantity = quantity / parseFloat(ingredient.real_weight);
          //
          var _quantity_f = this.globals.calculateQuantity(_real_quantity, ing_foodcost.quantity_gross, ing_foodcost.measurement_static);
          this.insert(_quantity_f, 'ingredient', ing_foodcost.uid, 'dishmenu');
        }
      } else {
        var _quantity = this.globals.calculateQuantity(quantity, element.quantity_gross / parseFloat(dish.foodcost_parts), element.measurement_static);
        this.insert(_quantity, 'ingredient', element.uid, 'dishmenu');
      }
    }
  }

  async getInsertIng(uid, quantity) {
    var ingredient = await this.ingredientsServices.getIngredient(uid);
    for (let element of this.globals.objectToArray(ingredient.foodcost)) {
      var _ingredient = await this.ingredientsServices.getIngredient(element.uid);
      if (_ingredient.sub_recipe) {
        for (let ing_foodcost of this.globals.objectToArray(_ingredient.foodcost)) {
          //usamos el real_weight para sacar la cantidad que queremos
          var _real_quantity_s = quantity / parseFloat(ingredient.real_weight);
          //
          var _quantity_f = this.globals.calculateQuantity(_real_quantity_s, ing_foodcost.quantity_gross, ing_foodcost.measurement_static);
          this.insert(_quantity_f, 'ingredient', ing_foodcost.uid, 'dishmenu');
        }
      } else {
        //usamos el real_weight para sacar la cantidad que queremos
        var _real_quantity = quantity / parseFloat(ingredient.real_weight);
        //
        var _quantity = this.globals.calculateQuantity(_real_quantity, element.quantity_gross, element.measurement_static);
        this.insert(_quantity, 'ingredient', element.uid, 'dishmenu');
      }
    }
  }

  async getInsertProd(uid, quantity) {
    var product = await this.productsServices.getProduct(uid);
    for (let element of this.globals.objectToArray(product.foodcost)) {
      var ingredient = await this.ingredientsServices.getIngredient(element.uid);
      if (ingredient.sub_recipe) {
        for (let ing_foodcost of this.globals.objectToArray(ingredient.foodcost)) {
          var _quantity_f = this.globals.calculateQuantity(quantity, ing_foodcost.quantity_gross / parseFloat(product.foodcost_parts), ing_foodcost.measurement_static);
          this.insert(_quantity_f, 'ingredient', ing_foodcost.uid, 'dishmenu');
        }
      } else {
        var _quantity = this.globals.calculateQuantity(quantity, element.quantity_gross / parseFloat(product.foodcost_parts), element.measurement_static);
        this.insert(_quantity, 'ingredient', element.uid, 'dishmenu');
      }
    }
  }

  present() {
    //toast
    let toast = this.toastCtrl.create({
      message: this.translate.instant('instant-anadido-correctamente-cesta'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
    //pop
    this.navCtrl.pop();
  }

  listDish() {
    this.navCtrl.push(ProviderOrderAddDishPage, {
      quantity: this.quantity,
      uid: this.element,
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/providers/orders/provider-order-add/provider-order-add.ts